import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouter = ({ token: propToken }) => {
  // Check for token in URL (for auto-login redirect)
  const params = new URLSearchParams(window.location.search);
  const urlToken = params.get("token");

  if (urlToken) {
    localStorage.setItem("GSTB_token", urlToken);
    // Remove token from URL and reload to initialize app with new token
    params.delete("token");
    const newSearch = params.toString();
    const newUrl = `${window.location.pathname}${newSearch ? "?" + newSearch : ""}${window.location.hash}`;
    window.location.href = newUrl; // Hard reload
    return null; // Stop rendering until reload
  }

  // prefer prop but fall back to latest value from localStorage
  const authToken = propToken || localStorage.getItem("GSTB_token");

  if (!authToken) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRouter;
